import $ from 'jquery';
import debug from 'debug';
const log = debug('core/plugins/lib/selectors');

export function selectorPattern (...directives) {
	return new RegExp(`\\((${directives.join('|')})(.*)\\)\\s?(.*)`);
}

export const SELECTOR_PATTERNS = {

	// .find
	"children": selectorPattern('children'),

	// .closest
	"parent": selectorPattern('parent'),
	"from": selectorPattern('from'),
	"parents": selectorPattern('parents'),
	"siblings": selectorPattern('siblings'),
	"here": selectorPattern('here'),
	"self": selectorPattern('self'),
};

export function selectTarget(selector, $element) {
	let $target;

	const isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
	const isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
	const isRetargeted = selector.match(SELECTOR_PATTERNS.from);
	const isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
	const isGenerational = selector.match(SELECTOR_PATTERNS.here);
	const isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
	const isSelfish = selector.match(SELECTOR_PATTERNS.self);

	// special retargeting root
	if (isRetargeted) {
		log('isRetargeted', isRetargeted[2], isRetargeted[3]);
		const $newElement = selectTarget(isRetargeted[2], $element);
		const newSelector = `(children) ${isRetargeted[3]}`;
		log('isRetargeted.newElement', $newElement);
		log('isRetargeted.newSelector', newSelector);
		$target = selectTarget(newSelector, $newElement);
		log('isRetargeted.target', $target);
	}

	// target is all ancestors
	else if (isAllAncestoral) {
		log('isAllAncestoral', isAllAncestoral);
		$target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
	}
	// target is closest ancestor
	else if (isClosestAncestoral) {
		log('isClosestAncestoral', isClosestAncestoral);
		$target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
	}
	// target is somewhere under current parent
	else if (isGenerational) {
		log('isGenerational', isGenerational);
		$target = $element.parent().find(isGenerational[isGenerational.length - 1]);
	}
	// target is only under self
	else if (isAllDescendants) {
		log('isAllDescendants', isAllDescendants);
		$target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
	}
	// target is somewhere in siblings only
	else if (isSiblings) {
		log('isSiblings', isSiblings);
		$target = $element.siblings(isSiblings[isSiblings.length - 1]);
	}
	// target is source
	else if (!selector || isSelfish) {
		log('isSelfish', isSelfish);
		var selector = isSelfish[isSelfish.length - 1] || '*';
		$target = $element.filter(selector);
	}
	// target could be anywhere
	else {
		log('global', selector);
		$target = $(selector);
	}
	return $target;
}

class OnAvailable {
	constructor(root) {
		this.root = root || window.document.documentElement;
		this.listeners = [];
		this.observer;
	}

	ready(selector, fn) {
		// Store the selector and callback to be monitored
		this.listeners.push({
			selector: selector,
			fn: fn,
		});

		if (!this.observer) {
			// Watch for changes in the document
			this.observer = onChange(this.root, this.check.bind(this), {
				childList: true,
				subtree: true,
			});
		}
		// Check if the element is currently in the DOM
		this.check();
	}

	check() {
		// Check the DOM for elements matching a stored selector
		for (
			var i = 0, len = this.listeners.length, listener, elements;
			i < len;
			i++
		) {
			listener = this.listeners[i];
			// Query for elements matching the specified selector
			elements = this.root.querySelectorAll(listener.selector);
			for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
				element = elements[j];
				// Make sure the callback isn't invoked with the
				// same element more than once
				if (!element.ready) {
					element.ready = true;
					// Invoke the callback with the element
					listener.fn.call(element, element);
				}
			}
		}
	}
}

export var onAvailable = new OnAvailable(window.document.documentElement);

export function onChange(element, fn, options) {
	var MutationObserver =
	window.MutationObserver || window.WebKitMutationObserver;
	var observer = new MutationObserver(fn);
	observer.observe(
		element,
		options || {
			attributes: true,
			childList: true,
			subtree: true,
		}
	);
	return observer;
}



// WEBPACK FOOTER //
// ./client/src/core/plugins/lib/selectors.js